import React, { useContext, useEffect, useState } from "react";
import "../css/page1.css";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import { message } from "antd";
import { useParams } from "react-router-dom";
// import { GlobalDataContext } from "../GlobalDataContext";

const Page1 = (params) => {
  const { id } = useParams();
  // let backgroundImage = `/images/background${params.bgimage.toString() || "1"}.png`;
   const [backgroundImage, setBackgroundImage] = useState(
    `/images/background${params.bgimage?.toString() || "1"}.png`
  );
  useEffect(() => {
    const fetchReportStyle = async () => {
      try {
        // const response = await fetch("http://localhost:1337/getReportStyleByKit", {
        const response = await fetch("https://yourgutmap-food-sensitivity-423a2af84621.herokuapp.com/getReportStyleByKit", {
        // const response = await fetch("http://192.168.100.48:1338/getReportStyleByKit", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ kitId: id }), // Send the kit ID
        });

        const result = await response.json();

        if (response.ok && result.style && result.style.styleName !== "YourGutMap") {
          setBackgroundImage(result.style.header)
          // Update colors and logo if style data exists
          // setPrimaryColor(result.style.primaryColor);
          // setSecondaryColor(result.style.secondaryColor);
          // setLogo(result.style.imageBase64);
          // setStyleName(result.style.styleName);
          // setHeader(result.style.header);
          // setFooter(result.style.footer);
          // setIsUpdated(true)
          // setPortalId(result.style._id);
          // setStyleUpdated(true);
          // console.log(primaryColor)
        }
        console.log("Report style fetched successfully:", result?.style?.header);
        
      } catch (error) {
        console.error("Error fetching report style:", error);
      }
    };

    fetchReportStyle();
  }, [id]); // Runs when the component mounts


  // if (params.header && params.styleName !== "YourGutMap") {
  // let  backgroundImage = params?.header?.toString() 
    // || `/images/background${params.bgimage.toString() || "1"}.png`;
  // }
  //   const { kitid, SampleDate, patientName } = useContext(GlobalDataContext);
  
  const kitid = params.kitid;
  const resultDate = params.resultDate;
  const patientName = params.patientName;
  const waitForLogoToLoad = () => {
    return new Promise((resolve) => {
      const img = document.getElementById("report-logo");
      if (!img) return resolve(); // No logo? Just resolve.

      if (img.complete) {
        resolve(); // Already loaded
      } else {
        img.onload = resolve;
        img.onerror = resolve; // still resolve to avoid hanging
      }
    });
  };
  const download = async () => {
    await waitForLogoToLoad();
    await new Promise((resolve) => setTimeout(resolve, 300));
    const hide = message.loading("Your report is downloading", 0);
    const button = document.getElementById("downloadButton");
    if (button) button.classList.add("hide-for-pdf");

    try {
      const pdf = new jsPDF();
      const pages = document.querySelectorAll(".page1");

      for (let i = 0; i < pages.length; i++) {
        await new Promise((resolve) => setTimeout(resolve, 100));
        const canvas = await html2canvas(pages[i], { scale: 2 }); // Higher scale for better quality
        const imgData = canvas.toDataURL("image/jpeg", 0.9); // JPEG format with 90% quality

        if (i > 0) {
          pdf.addPage();
        }

        const pageWidth = pdf.internal.pageSize.getWidth();
        const pageHeight = pdf.internal.pageSize.getHeight();
        const imgWidth = pageWidth;
        const imgHeight = (canvas.height * pageWidth) / canvas.width; // Maintain aspect ratio

        pdf.addImage(
          imgData,
          "JPEG",
          0,
          0,
          imgWidth,
          imgHeight,
          undefined,
          "MEDIUM"
        );
      }

      pdf.save("food-sensitivity-report.pdf");


      hide();
      message.success("Report has been downloaded Successfully!");
    } catch (error) {
      console.log(error)
    }

    button?.classList.remove("hide-for-pdf");
  };

  return (
    <div className="page page1">
      <div className="bg">
        <img src={backgroundImage} alt="" />
      </div>
      <div className="content">
        <img id="report-logo" src={params.logo} alt="" width={'300px'} style={{ width: "260px" }} />
        <h1
          className="headingnew"
          style={{
            marginBottom: params.page1 ? "0px" : "",
            color: params.primaryColor || "#6e4e9f",
            fontSize: params.page1 ? "53px" : "",
            fontWeight: params.page1 ? "bold" : "",
          }}
        >
          {/* {params.mainHeading} */}
          FoodSensitivity<span style={{ color: params.secondaryColor }}>Map</span>
        </h1>
        <button
          style={{
            position: "absolute",
            top: "31rem",

            width: "350px",
            height: "50px",
            border: "none",
            borderRadius: "10px",
            background: params.primaryColor,
            fontSize: "25px",
            color: "white",
            // color: `${reportStyle["primaryColor"]}`
          }}
          className=""
          id="downloadButton"
          onClick={download}
        >
          Download
        </button>
        {params.page1 ? (
          <h1
            className="headingnew"
            style={{
              color: params.color || "#4080b8",
              fontSize: params.page1 ? "33px" : "",
              fontWeight: params.page1 ? "bold" : "",
            }}
          >
            {params.subHeading}
          </h1>
        ) : (
          <div
            className="heading2new"
            style={{
              // background: params.bg  || "#4080b8",
              background: params.gradient
                ? "linear-gradient(to right, #E9F7FF, #E6DEFF)"
                : params.bg || "#4080b8",
              color: params.gradient ? "#6e4e9f" : params.color || "white",
            }}
          >
            <h2 className="">{params.subHeading}</h2>
          </div>
        )}
        {params.id ? (
          <div className="ids">
            <div className="keys">
              <div className="">Sample ID</div>
              <div className="">Patient Name</div>
              <div className="">Result Date</div>
            </div>
            <div className="values">
              <div className="">
                {/* <span style={{ paddingRight: "20px" }}>:</span> {kitid} */}
                <span style={{ paddingRight: "20px" }}>:</span>
              </div>
              <div className="">
                {/* <span style={{ paddingRight: "20px"}}>:</span> {patientName} */}
                <span style={{ paddingRight: "20px" }}>:</span> Example Report
              </div>
              <div className="">
                {/* <span style={{ paddingRight: "20px" }}>:</span>{resultDate} */}
                <span style={{ paddingRight: "20px" }}>:</span>
              </div>
            </div>
          </div>
        ) : (
          ""
        )}
      </div>
    </div>
  );
};

export default Page1;
